export default "__VITE_ASSET__C45SiYtl__"